export type GestureKind = 'idle' | 'orbit' | 'pan' | 'drag'
export interface PointerPoint { readonly x: number; readonly y: number }
export interface GestureMovement { readonly kind: GestureKind; readonly dx: number; readonly dy: number; readonly moved: boolean }

/** One captured pointer owns a gesture. The threshold distinguishes a click from a carry. */
export class GestureController {
  private pointer: { id: number; origin: PointerPoint; last: PointerPoint; candidate: Exclude<GestureKind, 'idle'> } | null = null
  kind: GestureKind = 'idle'
  moved = false

  begin(id: number, point: PointerPoint, candidate: Exclude<GestureKind, 'idle'>): boolean {
    if (this.pointer) return false
    this.pointer = { id, origin: point, last: point, candidate }
    this.kind = 'idle'
    this.moved = false
    return true
  }

  move(id: number, point: PointerPoint): GestureMovement | null {
    const pointer = this.pointer
    if (!pointer || pointer.id !== id) return null
    const dx = point.x - pointer.last.x, dy = point.y - pointer.last.y
    if (Math.hypot(point.x - pointer.origin.x, point.y - pointer.origin.y) >= 6) {
      this.moved = true
      this.kind = pointer.candidate
    }
    pointer.last = point
    return { kind: this.kind, dx, dy, moved: this.moved }
  }

  end(id: number): { kind: GestureKind; moved: boolean } | null {
    if (this.pointer?.id !== id) return null
    const result = { kind: this.kind, moved: this.moved }
    this.cancel()
    return result
  }

  cancel(): void { this.pointer = null; this.kind = 'idle'; this.moved = false }
}
